/* new revision */
:global(.noselect) {
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Old versions of Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none;
	/* Non-prefixed version, currently
                                       supported by Chrome, Edge, Opera and Firefox */
}

/* end of new revision */

.editQuizContainer {
	min-width: max(206px, 100%);
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	overflow: hidden;
	gap: 1rem;
	height: 100%;
	margin: 0;
}

.stepperContainer {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	max-width: min(25%, 220px);
	width: 100%;
}

.modalBody {
	overflow-y: auto;
	flex: 1;
	padding-right: 2.5rem;
	padding-top: 0.625rem;
	box-sizing: border-box;
	scrollbar-gutter: stable;
}

.modalBody::-webkit-scrollbar-track {
	background: transparent;
}

.modalBody:focus-visible {
	outline: none; /* UX team doesn't want focus outline */
}

@media (max-width: 768px) {
	.editQuizContainer {
		flex-direction: column;
		width: 100%;
		gap: 0.75rem;
		background-color: #f4f4f4;
		margin-bottom: 0.625rem;
		align-items: flex-start;
		justify-content: center;
		height: unset;
	}

	.stepperContainer {
		width: 100%;
		max-width: 100%;
		gap: 1rem;
		padding: 0;
		height: unset;
	}

	.modalBody {
		flex: unset;
		background-color: #f4f4f4;
		padding-right: 0;
		padding-top: 0;
		width: 100%;

		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* IE/Edge */
	}

	.modalBody::-webkit-scrollbar {
		display: none; /* Chrome, Safari, Opera */
	}
}
